export default __webpack_public_path__ + "static/media/logo.37dd3ac6fe7817177385c88dd72ae6c6.svg";